import { useParams, Link } from 'react-router-dom';
import { categories, movies } from '@/mocks/data';

interface CategoryFilterProps {
  active: string;
}

export default function CategoryFilter({ active }: CategoryFilterProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
            active === cat.slug
              ? 'bg-primary-500 text-background-950'
              : 'bg-background-200/40 text-foreground-400 hover:text-foreground-200 hover:bg-background-200/60 border border-background-200/30'
          }`}
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className={`${cat.icon} text-sm`}></i>
          </div>
          {cat.name}
        </Link>
      ))}
    </div>
  );
}